import { useEffect, useState } from "react";
import { CONSENT_EVENT, getConsent, setConsent } from "@/analytics/ga4";

const btn = "px-4 py-2 rounded-sm text-xs font-semibold transition-colors";

export const ConsentBanner = () => {
  const [choice, setChoice] = useState(() => getConsent());

  useEffect(() => {
    const onChange = () => setChoice(getConsent());
    window.addEventListener(CONSENT_EVENT, onChange);
    return () => window.removeEventListener(CONSENT_EVENT, onChange);
  }, []);

  if (choice) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Analytics cookie preferences"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-50 bg-navy-900 text-ivory-50 border border-gold-500/40 rounded-sm p-5 shadow-2xl"
      data-testid="consent-banner"
    >
      <p className="editorial-overline !text-gold-400">Cookies &amp; analytics</p>
      <p className="text-sm text-ivory-200/80 mt-2 leading-relaxed">
        TrendRise AI works fully without analytics cookies — sign-in and all features are unaffected.
        Optional analytics (Google Analytics 4, no advertising) helps us understand how the site and product are used.
      </p>
      <div className="mt-4 flex gap-2">
        <button onClick={() => setConsent("denied")} className={`${btn} flex-1 border border-ivory-200/30 text-ivory-50 hover:border-gold-500`} data-testid="consent-reject">
          Reject analytics
        </button>
        <button onClick={() => setConsent("granted")} className={`${btn} flex-1 bg-gold-500 hover:bg-gold-400 text-navy-900`} data-testid="consent-accept">
          Accept analytics
        </button>
      </div>
    </div>
  );
};
